import { Scale } from "@hydrologiq/schemas/1.0.0/installationPage"

export const LAST_30_MINUTES_SCALE: Scale = {
  normal: { quantity: 5, resolution: "minute" },
  mobile: { quantity: 1, resolution: "minute" },
}

export const LAST_1_HOUR_SCALE: Scale = {
  normal: { quantity: 5, resolution: "minute" },
  mobile: { quantity: 30, resolution: "minute" },
}

export const LAST_3_HOURS_SCALE: Scale = {
  normal: { quantity: 15, resolution: "minute" },
  mobile: { quantity: 45, resolution: "minute" },
}

export const LAST_6_HOURS_SCALE: Scale = {
  normal: { quantity: 30, resolution: "minute" },
  mobile: { quantity: 1, resolution: "hour" },
}

export const LAST_12_HOURS_SCALE: Scale = {
  normal: { quantity: 1, resolution: "hour" },
  mobile: { quantity: 2, resolution: "hour" },
}

export const LAST_24_HOURS_SCALE: Scale = {
  normal: { quantity: 2, resolution: "hour" },
  mobile: { quantity: 3, resolution: "hour" },
}

export const LAST_WEEK_SCALE: Scale = {
  normal: { quantity: 12, resolution: "hour" },
  mobile: { quantity: 1, resolution: "day" },
}

export const LAST_WEEKS_SCALE: Scale = {
  normal: { quantity: 1, resolution: "day" },
  mobile: { quantity: 2, resolution: "day" },
}

export const LAST_MONTH_SCALE: Scale = {
  normal: { quantity: 1, resolution: "day" },
  mobile: { quantity: 3, resolution: "day" },
}

export const LAST_MONTHS_SCALE: Scale = {
  normal: { quantity: 2, resolution: "day" },
  mobile: { quantity: 5, resolution: "day" },
}

export const LAST_MONTHS_MORE_3_SCALE: Scale = {
  normal: { quantity: 7, resolution: "day" },
  mobile: { quantity: 14, resolution: "day" },
}
